import styles from './index.module.scss';
import { useLang } from '@/i18n';
import NextImage from '@/components/NextImage';

export default function SmartControl() {
    const { t } = useLang('powerstream.detail.control');

    return (
        <div className={styles.smartControl}>
            <div className="control-box">
                <NextImage
                    src={require('@publicLocal/power-stream/detail/pc/smart_control.jpg')}
                    webpSrc={require('@publicLocal/power-stream/detail/pc/smart_control.webp')}
                />
                <div className="top-box">
                    <p className="title">{t('title')}</p>
                    <p className="sub-title">{t('subTitle')}</p>
                    <p className="desc">{t('desc')}</p>
                </div>
            </div>
        </div>
    );
}
